import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UsuarioResponse } from '@/models/usuario.model';
import { PerfilUpdateRequest } from '@/models/perfil-update-request.model';
import { EnvironmentConfig } from '@/configs/environment.config';

@Injectable({
    providedIn: 'root'
})
export class PerfilService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = inject(EnvironmentConfig).getApiUrl() + '/usuarios/perfil';

    /**
     * Obtém o perfil do usuário logado
     */
    getPerfil(): Observable<UsuarioResponse> {
        return this.http.get<UsuarioResponse>(this.apiUrl);
    }

    /**
     * Atualiza o perfil do usuário logado
     * Apenas envia os campos que foram modificados
     */
    updatePerfil(perfil: PerfilUpdateRequest): Observable<UsuarioResponse> {
        return this.http.put<UsuarioResponse>(this.apiUrl, perfil);
    }

    /**
     * Faz upload da foto de perfil do usuário logado
     * A foto antiga será substituída automaticamente
     */
    uploadFotoPerfil(file: File): Observable<UsuarioResponse> {
        const formData = new FormData();

        formData.append('file', file);

        return this.http.post<UsuarioResponse>(`${this.apiUrl}/foto`, formData);
    }

    /**
     * Remove a foto de perfil do usuário logado
     */
    removerFotoPerfil(): Observable<UsuarioResponse> {
        return this.http.delete<UsuarioResponse>(`${this.apiUrl}/foto`);
    }
}
